/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import {
  createPortalSlotStyles,
  createScopedClasses
} from '../../assets/styles/createScopedStyles';
import mixins from '../../assets/styles/mixins.scss';

export const manageRosterStatusInfoModalStyles = {
  modalPaper: {
    borderRadius: 24,
    padding: 48,
    width: 640,
    maxWidth: 640,
    minWidth: 640,
    minHeight: 'auto',
    boxSizing: 'border-box',
    overflow: 'hidden',
    boxShadow: '0 1px 3px rgba(13, 0, 77, 0.04), 0 1px 0.5px rgba(13, 0, 77, 0.1), 0 2px 0.5px rgba(13, 0, 77, 0.15)',
    [mixins['md-sm-maxwidth']]: {
      width: 'calc(100vw - 32px)',
      maxWidth: 'calc(100vw - 32px)',
      minWidth: 0,
      padding: 24,
      borderRadius: 16
    }
  },
  modalCloseButton: {
    position: 'absolute',
    top: 16,
    right: 16,
    padding: 4,
    color: mixins.color_text_primary,
    height: 32,
    width: 32,
    '& svg': {
      height: 18,
      width: 18
    }
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    width: '100%'
  },
  modalHeader: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    width: '100%'
  },
  modalTitle: {
    margin: 0,
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: 24,
    fontWeight: mixins.fontWeight500,
    lineHeight: '32px',
    letterSpacing: '-0.48px',
    color: mixins.color_text_primary,
    fontFeatureSettings: '\'liga\' off'
  },
  modalBody: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  modalText: {
    width: '100%'
  },
  modalParagraph: {
    margin: 0,
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize16,
    fontWeight: mixins.fontWeight400,
    lineHeight: '24px',
    color: mixins.color_text_primary,
    fontFeatureSettings: '\'liga\' off',
    whiteSpace: 'pre-wrap'
  },
  modalParagraphFirst: {
    margin: 0,
    marginBottom: 16,
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize16,
    fontWeight: mixins.fontWeight400,
    lineHeight: '24px',
    color: mixins.color_text_primary,
    fontFeatureSettings: '\'liga\' off',
    whiteSpace: 'pre-wrap'
  }
};

export const manageRosterStatusInfoModalClasses = createScopedClasses(
  'aet-manage-roster-status-info-modal',
  manageRosterStatusInfoModalStyles
);

/** Used by ManageRosterStatusInfoModal only — not part of the public package API. */
export const manageRosterStatusInfoModalPortalSlotStyles = createPortalSlotStyles(
  manageRosterStatusInfoModalStyles,
  manageRosterStatusInfoModalClasses,
  [
    'modalPaper',
    'modalCloseButton',
    'modalContent',
    'modalHeader',
    'modalTitle',
    'modalBody',
    'modalText',
    'modalParagraph',
    'modalParagraphFirst'
  ],
  3
);
